module.exports = __webpack_public_path__ + "static/media/Nitika.5cabba3e.png";